import { render, staticRenderFns } from "./LabeledText.vue?vue&type=template&id=3234f990"
import script from "./LabeledText.vue?vue&type=script&lang=ts"
export * from "./LabeledText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports